import { render, staticRenderFns } from "./Objection.vue?vue&type=template&id=bf19e78a"
import script from "./Objection.vue?vue&type=script&lang=js"
export * from "./Objection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports